import {info} from "services-comun/modules/browser/log";

import { Ruta, IRuta } from "../ruta";
import { IConfig } from "../../config";
import {Auth} from "../../services/auth";

export class Home extends Ruta {
    /* STATIC */
    public static build(config: IConfig, id: number): Home {
        return new this({
            id,
            ruta: `${config.router.basePath}/`,
        });
    }

    /* INSTANCE */
    public constructor(data: IRuta) {
        super(data);
    }

    public async check(path: string): Promise<void> {
        if (path!=this.data.ruta) {
            return Promise.reject("Home: Rechazada");
        }
    }

    public async load(auth: Auth, config: IConfig, state?: any): Promise<void> {
        info("Cargando NavBar");
        const {NavBar} = await import(/* webpackChunkName: "navbar" */ `../../componentes/navbar`);
        await NavBar.load(auth, config, state);
        info("Cargando Home");
        const {Home} = await import(/* webpackChunkName: "home" */ `../../componentes/home`);
        await Home.load(auth, config, state);
    }

    public async unload(): Promise<void> {
        // info("Descargando NavBar");
        // const {NavBar} = await import(/* webpackChunkName: "navbar" */ `../../componentes/navbar`);
        // await NavBar.unload();
        info("Descargando Home");
        const {Home} = await import(/* webpackChunkName: "home" */ `../../componentes/home`);
        await Home.unload();
    }

    public async updateEstado(state?: any): Promise<void> {
        info("Actualizando el estado de NavBar");
        const {NavBar} = await import(/* webpackChunkName: "navbar" */ `../../componentes/navbar`);
        await NavBar.updateEstado(state);
        info("Actualizando el estado de Home");
        const {Home} = await import(/* webpackChunkName: "home" */ `../../componentes/home`);
        await Home.updateEstado(state);
    }
}
